var React = require('react');

function LinkedInIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.57522 19.9101H0.455206V6.61714H4.57522V19.9101ZM2.513 4.80386C1.19555 4.80386 0.126953 3.71056 0.126953 2.3906C0.126953 1.75657 0.378339 1.14851 0.825809 0.700189C1.27328 0.251866 1.88018 0 2.513 0C3.14582 0 3.75272 0.251866 4.20019 0.700189C4.64766 1.14851 4.89904 1.75657 4.89904 2.3906C4.89904 3.71056 3.83 4.80386 2.513 4.80386ZM19.9951 19.9101H15.884V13.4392C15.884 11.897 15.8529 9.91926 13.7419 9.91926C11.5998 9.91926 11.2716 11.5948 11.2716 13.328V19.9101H7.156V6.61714H11.1075V8.43042H11.1651C11.7152 7.386 13.0588 6.28381 15.0634 6.28381C19.2331 6.28381 19.9996 9.03484 19.9996 12.6081V19.9101H19.9951Z","fill":"white"}));
}

LinkedInIcon.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = LinkedInIcon;

LinkedInIcon.default = LinkedInIcon;
